module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEX///8hRouuHChfbmbQAAAAKElEQVRIx2NYhQOsGJUZlRmVoUBmFIyCUUALEIoDhIzKjMqMypAvAwBF7jWSS5At0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Netherlands.png
// module id = 600
// module chunks = 0